import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c4ec6efe&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c4ec6efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ec6efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4ec6efe')) {
      api.createRecord('c4ec6efe', component.options)
    } else {
      api.reload('c4ec6efe', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c4ec6efe&scoped=true&", function () {
      api.rerender('c4ec6efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zKtrjj6oLw8J/JS/comp/GuestBox.vue"
export default component.exports